module.exports = __webpack_public_path__ + "media/travis-scott-sicko-mode-ft-drake-official-video.5e4403cf.mp3";